/**
 * UN ENLACE ESCRITO EN UN ANUNCIO SE PUEDE PULSAR.
 *
 * Lissette, 2026-09-04, queja 66: *"en los anuncios, si se coloca un link que
 * salga en modo que se pueda click e ir al sitio del link"*.
 *
 * Hasta ahora el cuerpo del anuncio se pintaba como texto plano, asi que la
 * direccion salia escrita pero muerta: habia que seleccionarla, copiarla y
 * pegarla en el navegador.
 *
 * ── COMO SE HACE, Y POR QUE ASI ─────────────────────────────────────────────
 *
 * NO se genera HTML. Esta funcion parte el texto en TROZOS y la pantalla pinta
 * cada uno: los de texto tal cual, y los de enlace dentro de un <a>. Armar
 * HTML y volcarlo con `dangerouslySetInnerHTML` habria metido en la pantalla
 * texto que escribe otra persona — y la CSP de la aplicacion existe justo para
 * que eso no pase.
 *
 * SOLO http y https. Un `javascript:...` escrito en un anuncio se quedaria en
 * texto, como debe: pulsarlo ejecutaria codigo dentro de la sesion de quien lo
 * lee. Tambien se acepta `www.` sin esquema, que es como la gente escribe las
 * direcciones, y se le pone `https://` al abrirlo.
 *
 * LA PUNTUACION DEL FINAL NO ENTRA EN EL ENLACE. "Mira deskte.com/ayuda." o
 * "(ver https://x.com/y)" son la forma normal de escribir: si el punto o el
 * parentesis se colaran dentro, el enlace llevaria a una pagina que no existe.
 *
 * Modulo sin React a proposito: se prueba sin montar nada.
 */

/**
 * Direcciones dentro del texto: con esquema (http/https) o empezando por www.
 * El limite de la izquierda evita partir algo mas largo por la mitad.
 */
const DIRECCION = /\b(?:https?:\/\/|www\.)[^\s<>"']+/gi;

/** La puntuacion con la que suele acabar una frase, no la direccion. */
function recortarPuntuacionFinal(url) {
  let u = url;
  let sobra = '';
  for (;;) {
    const ultimo = u.slice(-1);
    if (!'.,;:!?"\''.includes(ultimo)) {
      // Un parentesis de cierre solo sobra si no habia uno de apertura dentro.
      if (ultimo === ')' && (u.match(/\(/g) || []).length < (u.match(/\)/g) || []).length) {
        sobra = ultimo + sobra; u = u.slice(0, -1); continue;
      }
      break;
    }
    sobra = ultimo + sobra;
    u = u.slice(0, -1);
  }
  return { url: u, sobra };
}

/** A donde lleva de verdad: `www.x.com` se abre como `https://www.x.com`. */
export function destinoDelEnlace(texto) {
  const t = String(texto || '');
  return /^www\./i.test(t) ? `https://${t}` : t;
}

/**
 * El texto partido en trozos para pintarlo.
 *
 * @returns {Array<{tipo:'texto'|'enlace', valor:string, href?:string}>}
 */
export function trozosConEnlaces(texto) {
  const t = String(texto == null ? '' : texto);
  if (!t) return [];
  const out = [];
  let ultimo = 0;
  DIRECCION.lastIndex = 0;
  let m;
  while ((m = DIRECCION.exec(t)) !== null) {
    const { url, sobra } = recortarPuntuacionFinal(m[0]);
    if (!url) continue;
    if (m.index > ultimo) out.push({ tipo: 'texto', valor: t.slice(ultimo, m.index) });
    out.push({ tipo: 'enlace', valor: url, href: destinoDelEnlace(url) });
    if (sobra) out.push({ tipo: 'texto', valor: sobra });
    ultimo = m.index + m[0].length;
  }
  if (ultimo < t.length) out.push({ tipo: 'texto', valor: t.slice(ultimo) });
  return out;
}

/** ¿Hace falta partirlo? Para no cambiar nada cuando no hay enlaces. */
export function tieneEnlaces(texto) {
  DIRECCION.lastIndex = 0;
  return DIRECCION.test(String(texto || ''));
}
